import { render } from "./LangSelect.vue?vue&type=template&id=8430d068"
import script from "./LangSelect.vue?vue&type=script&lang=js"
export * from "./LangSelect.vue?vue&type=script&lang=js"

import "./LangSelect.vue?vue&type=style&index=0&id=8430d068&lang=scss"

import exportComponent from "/codebuild/output/src719114813/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__